"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminDashboardDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class AdminDashboardDto {}
exports.AdminDashboardDto = AdminDashboardDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: ['7d', '30d', '90d', 'all']
}), __metadata("design:type", String)], AdminDashboardDto.prototype, "period", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminDashboardDto.prototype, "periodLabel", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "visits", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "activeUsers", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "activeVenues", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "messages", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "breadcrumbs", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "recentViews", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "rsvps", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "visitPlans", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "visitsByState", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminDashboardDto.prototype, "monthlyVisits", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [Object]
}), __metadata("design:type", Array)], AdminDashboardDto.prototype, "topUsers", void 0);
//# sourceMappingURL=AdminDashboard.dto.js.map